import { render, staticRenderFns } from "./ModalEditFolder.vue?vue&type=template&id=4bea327c&"
import script from "./ModalEditFolder.vue?vue&type=script&lang=ts&"
export * from "./ModalEditFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports